import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL || "https://sso.redemptio.app",
  realm: process.env.REACT_APP_KEYCLOAK_REALM || "Liguori",
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "redacamy-frappe",
});

export default keycloak;
